// Từ điển nhãn thẻ của màn Ca vận hành.
//
// Vì sao tách ra khỏi component: bài hướng dẫn nói về những thẻ người đọc đang
// nhìn thấy, nên tên thẻ trong bài phải là CHÍNH tên trên màn. Gõ chuỗi ở hai
// nơi thì đổi một nơi là hướng dẫn lặng lẽ chỉ tới một thẻ không còn tồn tại —
// không có gì nổ, vì chữ trong bài chỉ là chuỗi.
//
// Khoá ở đây chính là `value` của `TabsTrigger` trên màn, nên hộp hướng dẫn mở
// thẳng được vào thẻ người đọc đang đứng.

export const BRANCH_SHIFT_TAB_LABEL = {
  today: "Ca hôm nay",
  chain: "Toàn chuỗi",
  week: "Lịch tuần",
  incidents: "Sự cố",
  templates: "Mẫu & phụ cấp",
  makeupFaces: "Duyệt số mặt",
} as const;

export type BranchShiftTabKey = keyof typeof BRANCH_SHIFT_TAB_LABEL;
